<template>
  <div class="login-statistics">
    <second-menu-link-content>
      <template v-slot:header>
        <span>登录统计</span>
      </template>
      <template v-slot:content>
        <div class="filter-custom-form-container" ref="formContainer">
          <el-form ref="filterClient" :model="filterClient" class="filter-customer-form">
            <div class="container">
              <el-form-item class="item" label="客户名称：" prop="name">
                <el-input
                  class="white"
                  clearable
                  v-model="filterClient.name"
                  placeholder="请输入客户名称"
                  @keyup.enter.native="toFilterClient"
                ></el-input>
              </el-form-item>
              <el-form-item class="item" label="登录时间：" prop="loginTime">
                <el-date-picker
                  v-model="filterClient.loginTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-button class="btn-blue" @click="toFilterClient">筛选</el-button>
            </div>
          </el-form>
        </div>
        <div class="table" ref="clientList">
          <el-table class="table-container" :data="tableList">
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :label="item.label"
              :prop="item.prop"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  class="btn-text"
                  type="text"
                  @click="lookDetails(scope.row)"
                >详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-tpl-container">
          <pagination-tpl
            class="pagination-tpl"
            :total="total"
            :currentPage="currentPage"
            @queryChange="handleQueryChange"
          ></pagination-tpl>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBClient from "models/db/client.js";
const dbClient = new DBClient();
import { formaTimeToSecond } from 'common/js/util.js';
export default {
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  },

  data() {
    return {
      filterClient: {
        name: '',
        loginTime: ''
      },
      total: 0,
      currentPage: 1,
      tableList: [],
      tableTitleList: [
        {label: '客户名称', prop: 'name'},
        {label: '登录账号', prop: 'loginAccount'},
        {label: '登录次数', prop: 'loginNums'},
        {label: '下单次数', prop: 'orderTimes'},
        {label: '登录时间', prop: 'loginTime'},
      ]
    }
  },

  created() {
    this.initLoginStatistics()
  },

  methods: {
    initLoginStatistics() {
      let currentPage = this.currentPage
      let name = this.filterClient.name
      let startTime = this.filterClient.loginTime?this.filterClient.loginTime[0]:''
      let endTime = this.filterClient.loginTime?this.filterClient.loginTime[1]:''
      let data = {
        currentPage,
        name,
        startTime,
        endTime
      }
      dbClient
        .getLoginStatistics(data)
        .then(res => {
          if (res.success) {
            let { totalNum, items } = res.result;
            this.total = totalNum;
            // 重置
            this.tableList = [];
            items.map(item => {
              this.tableList.push({
                userId: item.userId,
                name: item.xbName,
                loginAccount: item.username,
                loginNums: item.loginCount,
                loginTime: item.time ?formaTimeToSecond(item.time):'----',
                orderTimes: item.orderCount,
              });
            });
          } else {
            this.$message.error(res.message)
          }
        });
    },
    toFilterClient() {
      this.currentPage = 1
      this.initLoginStatistics()
    },
    handleQueryChange(query) {
      this.currentPage = query.currentPage
      this.initLoginStatistics()
    },
    lookDetails(row) {
      this.$router.push({
        path: "/admin/client/login-statistics-index/client-login",
        query: {
          userId: row.userId
        }
      });
    }
  }
}
</script>

<style lang='scss'>
.login-statistics {
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(96, 98, 102, 1);
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .filter-custom-form-container {
    width: 100%;
    box-sizing: border-box;
    margin: 16px 0 24px 0;
    padding: 22px 20px 6px 20px;
    background: rgba(245, 247, 250, 1);
    border-radius: 4px;
    .container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      .el-form-item {
        display: flex;
        margin-right: 20px;
      }
    }
  }
  
  .pagination-tpl-container {
    padding: 10px 24px 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
